module.exports = __webpack_public_path__ + "img/lastNameEle.6f0d9650.svg";